import { render, staticRenderFns } from "./TaskChartRatingItem.vue?vue&type=template&id=59c6beb6&scoped=true&"
import script from "./TaskChartRatingItem.vue?vue&type=script&lang=js&"
export * from "./TaskChartRatingItem.vue?vue&type=script&lang=js&"
import style0 from "./TaskChartRatingItem.vue?vue&type=style&index=0&id=59c6beb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c6beb6",
  null
  
)

export default component.exports